import bind from 'bind-decorator';
import JsonServiceClient from 'bz-stores/lib/JsonServiceClient';
import type { ClearAcceptConfigResponse, TakePaymentRequest } from 'tm3-core/api.dtos';
import {
  ClearAcceptConfigRequest,
  ClearAcceptStartPaymentCaptureRequest,
  StartVirtualTerminalPaymentCaptureRequest
} from 'tm3-core/api.dtos';

const getScript = (config: ClearAcceptConfigResponse) =>
  new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = config.scriptUrl ?? '';
    script.integrity = config.scriptSri ?? '';
    script.crossOrigin = 'anonymous';
    script.async = true;
    script.onerror = reject;

    script.onload = script.onreadystatechange = function () {
      const loadState = this.readyState;

      if (loadState && loadState !== 'loaded' && loadState !== 'complete') return;

      script.onload = script.onreadystatechange = null;

      resolve();
    };

    document.head.appendChild(script);
  });

export default class ClearAcceptStore {
  client: JsonServiceClient;
  constructor() {
    this.client = new JsonServiceClient();
    this.load();
  }

  @bind
  async load() {
    if (window.clearAcceptloadingPromise) return window.clearAcceptloadingPromise;
    try {
      const config = await this.loadConfigFromApi(); // if needed
      await getScript(config);
    } catch (ex) {
      console.error(ex);
      window.clearAcceptloadingPromise = null;
    }
  }
  @bind
  async loadConfigFromApi(): Promise<ClearAcceptConfigResponse> {
    const res = await this.client.get(new ClearAcceptConfigRequest());
    return res.result;
  }

  @bind
  async startPaymentCapture(
    amount: number,
    saveCard: boolean,
    locationId: number,
    paymentUrlCode: string,
    customerId: number, // virtual terminal only
    invoiceId: number, // virtual terminal only
    isVirtualTerminalMode: boolean,
    waitingListUrlCode: string
  ): Promise<TakePaymentRequest> {
    const Request = isVirtualTerminalMode
      ? StartVirtualTerminalPaymentCaptureRequest
      : ClearAcceptStartPaymentCaptureRequest;

    const res = await this.client.post(
      new Request({
        amount,
        locationId,
        saveCard,
        paymentUrlCode,
        customerId,
        invoiceId,
        waitingListUrlCode
      })
    );
    return res.result;
  }
}
